import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/components/Login';
import ListaDenuncias from '@/components/ListaDenuncias';
import CanalDenuncias from '@/components/CanalDenuncias';
import Acompanhamento from '@/components/Acompanhamento';
import ConsultaDenuncia from '@/components/ConsultaDenuncia';
import ReplicaDenuncia from '@/components/ReplicaDenuncia';
import * as uiv from 'uiv';
import auth from '@/middleware/auth';
import logged from '@/middleware/logged';

// Assinatura de Documentos
import ListarAssinaturas from '@/components/documentos/ListarAssinaturas'
import AssinarDocumento from '@/components/documentos/AssinarDocumento'

Vue.use(uiv);
Vue.use(Router);
Vue.use(uiv, {prefix: 'uiv'});

const router = new Router({
  base: process.env.BASE_URL,
  mode: 'history',
  routes: [
    {
      path: '/denuncia',
      name: 'Home',
      component: CanalDenuncias
    },
    {
      path: '/denuncia/replica-denuncia/:token',
      name: 'ReplicaDenuncia',
      component: ReplicaDenuncia,
      meta: {
        middleware: [auth],
      },
    },
    {
      path: '/denuncia/acompanhamento/:token',
      name: 'Acompanhamento',
      component: Acompanhamento
    },
    {
      path: '/denuncia/consulta-denuncia',
      name: 'ConsultaDenuncia',
      component: ConsultaDenuncia
    },
    {
      path: '/denuncia/login',
      name: 'Login',
      component: Login,
      meta: {
        middleware: [logged],
      },
    },
    {
      path: '/denuncia/lista-denuncias',
      name: 'ListaDenuncias',
      component: ListaDenuncias,
      meta: {
        middleware: [auth],
      },
    },

    // Seção dedicada a funcionalidade de assinatura de documentos
    // esta funcionalidade não tem relação com o resto do compliance

    {
      path: '/documentos/assinaturas',
      name: 'ListarAssinaturas',
      component: ListarAssinaturas,
      meta: {
        middleware: [auth],
      },
    },
    {
      path: '/documentos/assinar/:doc/:nomeDoc',
      name: 'AssinarDocumento',
      component: AssinarDocumento,
    },
  ],
});

function nextFactory(context, middleware, index) {
  const subsequentMiddleware = middleware[index];

  if (!subsequentMiddleware) return context.next;

  return (...parameters) => {
    context.next(...parameters);
    const nextMiddleware = nextFactory(context, middleware, index + 1);
    subsequentMiddleware({ ...context, next: nextMiddleware });
  };
}

router.beforeEach((to, from, next) => {
  if (to.meta.middleware) {
    const middleware = Array.isArray(to.meta.middleware)
      ? to.meta.middleware
      : [to.meta.middleware];

    const context = {
      from,
      next,
      router,
      to,
    };
    const nextMiddleware = nextFactory(context, middleware, 1);

    return middleware[0]({ ...context, next: nextMiddleware });
  }

  return next();
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js